const Radius = {
  L: 20,
  M: 6,
  S: 4,
  XS: 2,
}

export default Radius
